/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import Popover from '@react/react-spectrum/Popover';
import React, {lazy, Suspense} from 'react';
import Wait from '@react/react-spectrum/Wait';

const ShellOrgSwitcher = lazy(() => import('./ShellOrgSwitcher'));

export default function ShellOrgSwitcherPopover({locale, ...otherProps}) {
  return (
    <Popover
      isDialog={false}
      role="dialog"
      {...otherProps}>
      <Suspense fallback={<Wait centered />}>
        <ShellOrgSwitcher locale={locale} {...otherProps} />
      </Suspense>
    </Popover>
  );
}
